export default __webpack_public_path__ + "static/media/banner11.579e2707.jpeg";